import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import CommunityGalleryActions from 'actions/CommunityGalleryActions';
import ProductActions from 'actions/ProductActions';
import LoveActions from 'actions/LoveActions';
import { createStructuredSelector, createSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import ProductQuickLookModalEN from 'components/GlobalModals/QuickLookModal/ProductQuickLookModal/locales/ProductQuickLookModal_en_US';
import ProductQuickLookModalFR from 'components/GlobalModals/QuickLookModal/ProductQuickLookModal/locales/ProductQuickLookModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { toggleGalleryLightBox } = CommunityGalleryActions;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(ProductQuickLookModalEN, ProductQuickLookModalFR);

const fields = createSelector(
    createStructuredSelector({
        seeFullDetails: getTextFromResource(getText, 'seeFullDetails')
    }),
    localization => {
        return {
            localization
        };
    }
);

const functions = {
    toggleGalleryLightBox,
    updateCurrentProduct: ProductActions.updateCurrentProduct,
    setCurrentProduct: LoveActions.setCurrentProduct
};

const withProductQuickLookModalProps = wrapHOC(connect(fields, functions));

export {
    withProductQuickLookModalProps, fields, functions
};
